<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'm/task-process/attach/richlink/modal-title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" class="close-modal-button">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [formGroup]="richLinkForm">
  <ion-item lines="none">
    <ion-text color="medium" class="thumbnail-text">
      {{ 'm/task-process/attach/richlink/video-and-image-thumbnail' | translate }}
    </ion-text>
  </ion-item>

  <ion-item lines="none">
    <ion-button *ngIf="!pictureURL" (click)="selectPicture()" size="default" fill="clear">
      <ion-icon slot="icon-only" name="image"></ion-icon>
    </ion-button>
    <ng-container *ngIf="pictureURL">
      <img ng-if="pictureUrl" [appJwtSrc]="pictureURL" />
      <ion-button (click)="removePicture()" slot="end" size="default" fill="clear">
        <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
      </ion-button>
    </ng-container>
  </ion-item>

  <ion-item lines="none">
    <ion-button *ngIf="!videoURL" (click)="selectVideo()" size="default" fill="clear">
      <ion-icon slot="icon-only" name="videocam"></ion-icon>
    </ion-button>
    <ng-container *ngIf="videoURL">
      <video autoplay muted controls>
        <source [appJwtSrc]="videoURL" />
      </video>
      <ion-button (click)="removeVideo()" slot="end" size="default" fill="clear">
        <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
      </ion-button>
    </ng-container>
  </ion-item>

  <ion-progress-bar *ngIf="isUploading" [value]="uploadProgress$ | async"></ion-progress-bar>
  <div class="error-container">
    <div *ngIf="richLinkForm.errors?.mediaRequired">
      {{ 'm/task-process/attach/richlink/video-or-image-required' | translate }}
    </div>
  </div>

  <ion-item>
    <ion-label position="floating" color="primary"
      >{{ 'm/task-process/attach/richlink/title' | translate }} *</ion-label
    >
    <ion-input type="text" formControlName="title"></ion-input>
  </ion-item>
  <div class="error-container">
    <div *ngIf="title.invalid && (title.dirty || title.touched)">
      <div *ngIf="title.errors.required">
        {{ 'm/common/form_errors/required' | translate }}
      </div>
    </div>
  </div>

  <ion-item>
    <ion-label position="floating" color="primary">{{ 'm/task-process/attach/richlink/url' | translate }} *</ion-label>
    <ion-input type="text" formControlName="url"></ion-input>
  </ion-item>
  <div class="error-container">
    <div *ngIf="url.invalid && (url.dirty || url.touched)">
      <div *ngIf="url.errors.required">
        {{ 'm/common/form_errors/required' | translate }}
      </div>
      <div *ngIf="url.errors.url">
        {{ 'm/common/form_errors/invalid_url' | translate }}
      </div>
    </div>
  </div>
</ion-content>
<input #fileInput (change)="onFileSelected($event)" hidden type="file" />
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="ok()" [disabled]="richLinkForm.invalid" fill="solid" color="primary" size="large">
        {{ 'm/ok' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
